/* eslint-disable react/react-in-jsx-scope */
import GBETNativeInterface from "../../../libs/gbetnativeinterface";

const setCookie = (name, time) => {
    try {
        const myCookie = GBEUtils.getCookie(name);

        if (myCookie) {
            return;
        }

        GBEUtils.setCookie(name, true, time, "None;Secure");
    } catch (ex) {
        console.error("SetCookie Exception: ", ex.message);
    }
};

const getCookie = (name) => {
    try {
        const myCookie = GBEUtils.getCookie(name);

        // eslint-disable-next-line quotes
        return myCookie === "";
    } catch (ex) {
        console.error("GetCookie Exception: ", ex.message);
    }
};

class BiometricUtils {
    static setNativeJavascript(thisComponent) {
        //this is for legacy code in native app()
        window.GBEMobileApp = {
            nativeToJavaScript: {
                goToLogin: function goToLogin() {
                    thisComponent.onLoginWidgetShow(true, { invokedFromNativeApp: true });
                },
                checkForLoginPage: function checkForLoginPage() { },
                login: function login(username, password) {
                    GBEglobal.isBiometricLoginAttempt = true; // If activePage is not login assume login was invoked following launch, therefore first transition to Login page

                    const reCaptchaGtvValue = GBEglobal.settings["system.reCAPTCHA.RequiredForEstablishSession"];
                    const reCaptchaEnabled =
                        (typeof reCaptchaGtvValue === "string" && reCaptchaGtvValue.toLowerCase() === "true") ||
                        reCaptchaGtvValue === true;

                    if (reCaptchaEnabled !== undefined && reCaptchaEnabled && configurationSettings.reCaptchaSiteKey) {
                        if (thisComponent.recaptchaHandlerId === undefined) {
                            thisComponent.recaptchaHandlerId = window.grecaptcha.render("irecaptcha", {
                                sitekey: configurationSettings.reCaptchaSiteKey,
                                size: "invisible",
                                callback: (token) => {
                                    thisComponent.onLoginRequest({
                                        username: username,
                                        password: password,
                                        reCAPTCHAToken: token
                                    });
                                },
                                "expired-callback": () => {
                                    window.grecaptcha.reset(thisComponent.recaptchaHandlerId);
                                }
                            });
                            window.grecaptcha.execute(thisComponent.recaptchaHandlerId);
                        } else {
                            window.grecaptcha.reset(thisComponent.recaptchaHandlerId);
                            window.grecaptcha.execute(thisComponent.recaptchaHandlerId);
                        }
                    } else {
                        thisComponent.onLoginRequest({ username: username, password: password });
                    }
                },
                showSecurityAndPasswordSettings: function (biometryType) {
                    function onBiometricChanged(e) {
                        if (e.currentTarget.checked) {
                            try {
                                if (GBETNativeInterface.isWKWebView) {
                                    console.log("showSecurityAndPasswordSettings (JS) #1");
                                    window.webkit.messageHandlers.javaScriptToSwift.postMessage({
                                        name: "activateBiometricAuthentication",
                                        login: "true"
                                    });
                                } else {
                                    GBETNativeApp.activateBiometricAuthentication("true");
                                }
                            } catch (ex) {
                                alert(ex.message);
                            }
                        } else {
                            if (GBETNativeInterface.isAndroidWebView) {
                                try {
                                    GBETNativeApp.deactivateBiometricAuthentication();
                                } catch (ex) {
                                    console.error(
                                        "Exception: BiometricHelper.js -> deactivateBiometricAuthentication ",
                                        ex.message
                                    );
                                }
                            } else {
                                window.webkit.messageHandlers.javaScriptToSwift.postMessage({
                                    name: "deactivateBiometricAuthentication"
                                });
                            }
                        }
                    }

                    const modalConfig = {
                        content: {
                            title: "Security Settings",
                            markup: (
                                <p className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        onChange={onBiometricChanged}
                                        id="flexSwitchCheckChecked"
                                    />{" "}
                                    <label className="form-check-label" htmlFor="flexSwitchCheckChecked">
                                        {biometryType || "Fingerprint Authentication"}
                                    </label>
                                </p>
                            )
                        },
                        extraClass: " smallModal",
                        onClose: function () {
                            //clearInterval(interval);
                        },
                        footerButtons: {
                            Cancel: {
                                Text: "Close",
                                onClick: function () {
                                    thisComponent.onModalClose();
                                }
                            }
                        }
                    };

                    const modal = BiometricUtils.setModal(modalConfig);
                    thisComponent.onShowModal(modal);
                },
                promptToUseBiometrics: function promptToUseBiometrics(biometryType) {
                    biometryType = biometryType || "Fingerprint Authentication";

                    function afterDialogClosed() {
                        var params = GBEglobal.establishUserSessionEnhancedParams || { refresh: false };
                        delete GBEglobal.establishUserSessionEnhancedParams;
                        thisComponent.establishUserSessionIAPISuccess(params);
                    }
                    function showLater() {
                        const modalLaterConfig = {
                            content: {
                                title: "Activate later?",
                                body: "You will be prompted again in 7 Days"
                            },
                            extraClass: " smallModal",
                            onClose: function () {
                                afterDialogClosed();
                            },
                            footerButtons: {
                                Cancel: {
                                    Text: "OK",
                                    onClick: function () {
                                        thisComponent.onModalClose();
                                        setCookie("BiometricLaterPrompt", 7);
                                        afterDialogClosed();
                                    }
                                }
                            }
                        };

                        const modal = BiometricUtils.setModal(modalLaterConfig);
                        thisComponent.onShowModal(modal);
                    }

                    biometryType = biometryType.replace("Authentication", "");
                    const modalConfig = {
                        content: {
                            title: "Enable Biometric Secure Login",
                            body: "Login faster and more securely with " + biometryType + " Unlock"
                        },
                        extraClass: " smallModal",
                        onClose: function () {
                            //clearInterval(interval);
                        },
                        footerButtons: {
                            Ok: {
                                Text: "Enable Secure Login",
                                onClick: function () {
                                    thisComponent.onModalClose();

                                    try {
                                        if (GBETNativeInterface.isWKWebView) {
                                            window.webkit.messageHandlers.javaScriptToSwift.postMessage({
                                                name: "activateBiometricAuthentication",
                                                login: "true"
                                            });
                                        } else {
                                            GBETNativeApp.activateBiometricAuthentication("true");
                                        }
                                    } catch (ex) {
                                        // alert(ex.message);
                                        console.error("Activating Biometrics Error: ", ex.message);
                                    }
                                }
                            },
                            Cancel: {
                                Text: "No Thanks",
                                onClick: function () {
                                    showLater();
                                    //indow.setTimeout(showLater, 1000);
                                    //thisComponent.onModalClose();
                                }
                            }
                        }
                    };

                    const modal = BiometricUtils.setModal(modalConfig);
                    thisComponent.onShowModal(modal);
                },
                notifyBiometricAuthenticationHasBeenActivated: function notifyBiometricAuthenticationHasBeenActivated(
                    login,
                    biometryType
                ) {
                    biometryType = biometryType || "Fingerprint";
                    biometryType = biometryType.replace("Authentication", "");

                    const modalConfig = {
                        content: {
                            title: "Enable Biometric Secure Login",
                            body: biometryType + " Unlock has now been activated"
                        },
                        extraClass: " smallModal",
                        onClose: function () {
                            //clearInterval(interval);
                        },
                        footerButtons: {
                            // Ok: {
                            //     Text: "OK",
                            // },
                            Cancel: {
                                Text: "OK",
                                onClick: function () {
                                    if (login === "true") {
                                        var params = GBEglobal.establishUserSessionEnhancedParams;
                                        delete GBEglobal.establishUserSessionEnhancedParams;

                                        // alert("cant call establihsession success");
                                        setCookie("BiometricActive", 99999);
                                        thisComponent.establishUserSessionIAPISuccess(params);
                                    }
                                    thisComponent.onModalClose();
                                }
                            }
                        }
                    };

                    const modal = BiometricUtils.setModal(modalConfig, false, "no-lock");
                    thisComponent.onShowModal(modal);
                },
                continueLogin: function continueLogin(isActiveBiometric) {
                    const myCookie = getCookie("BiometricLaterPrompt");
                    const biometricActive = getCookie("BiometricActive");

                    const regex = /Version ([2-9][4-9])(\.\d+)?/;
                    const isMatch = regex.test(navigator.userAgent);

                    var params = GBEglobal.establishUserSessionEnhancedParams;
                    delete GBEglobal.establishUserSessionEnhancedParams;
                    thisComponent.establishUserSessionIAPISuccess(params);

                    if (
                        myCookie &&
                        !isActiveBiometric &&
                        (isMatch || (GBETNativeInterface?.isWKWebView && biometricActive))
                    ) {
                        window?.GBEMobileApp?.nativeToJavaScript?.promptToUseBiometrics();
                    }
                },
                continueToSecurityAndPasswordPage: function continueToSecurityAndPasswordPage(
                    enrolmentResponse,
                    biometryType
                ) {
                    // alert("continueToSecurityAndPasswordPage");
                    //var data = GBEglobal.webViewData;
                    GBEglobal.webViewData = undefined;

                    biometryType = GBETNativeInterface.isWKWebView
                        ? biometryType || "Touch or Face ID"
                        : "Fingerprint Authentication";

                    window.showBiometricAuthentication = true;

                    const modalConfig = {
                        content: {
                            title: biometryType + " has been activated",
                            body: ""
                        },
                        onClose: function () {
                            //clearInterval(interval);
                        },
                        footerButtons: {
                            Ok: {
                                Text: "OK",
                                onClick: function () {
                                    thisComponent.onModalClose();
                                }
                            }
                        }
                    };

                    const modal = BiometricUtils.setModal(modalConfig);
                    thisComponent.onShowModal(modal);

                    //   var template = <ul data-role="listview" data-theme="c" data-dividertheme="g"></ul>
                    //                          <% if (showTwoFactorAuthentication) { %>
                    //   <li>
                    //   <a href="#security" data-transition="none">Two Step Authentication</a>
                    //   </li>
                    //   <% } %>
                    //                          <% if (showBiometricAuthentication) {
                    //   <li>
                    //<a href="#iOSBiometricAuthenticationSettings?enrolmentResponse=<%= enrolmentResponse %>&biometryType=<%= biometryType %>" data-transition="none"><%= biometryType %> Login</a>
                    //   </li>
                    //   <% } %>

                    //GBEMobileGEP.pages.securityAndPassword.injectSecurityAndPassword({
                    //    showBiometricAuthentication: true,
                    //    enrolmentResponse: enrolmentResponse,
                    //    biometryType: GBETNativeInterface.isWKWebView ? biometryType || 'Touch or Face ID' : 'Fingerprint Authentication'
                    //}, data.options);
                }
            }
        };
    }

    static getSomething() {
        return "something";
    }

    // TODO: Might be a better way to do this.
    // Function so that we can apply something to all modals
    static setModal(modal, skip = false, extraClass = "") {
        if (skip) return modal;

        modal.extraClass = (" gbe-biometric-modal " + extraClass).trimEnd();
        modal.removeCloseButton = true;

        return modal;
    }
}

export default BiometricUtils;
